export abstract class ZendeskModel {
  abstract accountUrl: string;
  abstract beforePageLoad(zE): any;
}
